import React, { useState } from "react";

import { useQuery } from "@apollo/client";

import GET_COURSE_BOOKING_INFO from "graphql/queries/GetCourseBookingInfo";

import NoClassToBookModal from "./NoClassToBookModal";
import BookCourseModal from "./BookCourseModal";

type BookAllProps = {
  currentCourseId: number;
  isHighestLevel: boolean;
  setCourseFromLocationId: (id: number) => void;
  setBookAll: (id: number) => void;
};

const BookAll = ({
  currentCourseId,
  isHighestLevel,
  setCourseFromLocationId,
  setBookAll,
}: BookAllProps) => {
  const [bookAllVisible, setBookAllVisible] = useState(true);

  const { data: courseData, loading: courseLoading } = useQuery(
    GET_COURSE_BOOKING_INFO,
    {
      skip: !currentCourseId,
      variables: {
        courseId: currentCourseId,
      },
      fetchPolicy: "network-only",
    }
  );

  const thereIsClassesToBook =
    courseData?.bookableFullCourse.remainingCourseCost > 0;

  return (
    <div className="with-black-screen">
      {currentCourseId && !thereIsClassesToBook && !courseLoading && (
        <NoClassToBookModal
          visible={bookAllVisible}
          onCloseModal={() => {
            setBookAllVisible(false);
            setBookAll(0);
          }}
          nextCourseId={
            !isHighestLevel ? Number(currentCourseId) + +1 : undefined
          }
          setCourseFromLocationId={
            !isHighestLevel ? setCourseFromLocationId : undefined
          }
        />
      )}
      {currentCourseId && thereIsClassesToBook && (
        <BookCourseModal
          visible={bookAllVisible}
          onCloseModal={() => {
            setBookAllVisible(false);
            setBookAll(0);
          }}
          courseData={courseData.bookableFullCourse}
        />
      )}
    </div>
  );
};

export default BookAll;
